import {Config} from "../types";

export class ModalWindow {
    private iframe: HTMLIFrameElement | null;
    private modal: HTMLElement | null;
    private outer: HTMLElement | null;
    private loader: HTMLElement | null;
    private serverUrl: string;
    private onClosed: (() => void) | undefined;
    private config: Config;

    constructor(serverUrl: string, config: Config, onClosed?: () => void) {
        this.serverUrl = serverUrl;
        this.config = config;
        // load styles
        this.loadStyles();

        // initialize the properties
        this.iframe = null;
        this.modal = null;
        this.outer = null;
        this.loader = null;
        this.onClosed = onClosed;
    }

    private createOuter(): void {
        // create and style your modal here
        this.outer = document.createElement('div');
        this.outer.className = 'pn-embed-modal-outer';

        document.body.appendChild(this.outer);

        // Add event listener to close the modal when clicked outside of the iframe
        this.outer.addEventListener('click', (e) => {
            if (e.target === this.outer) {
                // this.close();
            }
        });

        // Add close button
        this.createCloseButton();
    }

    private createModal(): void {
        this.modal = document.createElement('div');
        this.modal.className = 'pn-embed-modal';

        if (this.outer) {
            this.outer.appendChild(this.modal);
        }
    }
    private createIframe(): void {
        this.iframe = document.createElement('iframe');
        this.iframe.style.width = "100%";
        this.iframe.style.height = "100%";
        this.iframe.style.border = 'none';
        this.iframe.style.display = 'none';

        // Set additional properties here
        this.iframe.setAttribute('allowpaymentrequest', '');
        this.iframe.setAttribute('allowfullscreen', '');
        this.iframe.setAttribute('allow', 'fullscreen; payment');

        // on iframe load, hide the loader
        this.iframe.onload = () => {
            // this.hideLoader();
        }

        this.iframe.onerror = () => {
            console.error('Error loading iframe');
        }
        // // Add the sandbox properties
        // this.iframe.sandbox.add('allow-popups');
        // this.iframe.sandbox.add('allow-scripts');
        // this.iframe.sandbox.add('allow-same-origin');
        // this.iframe.sandbox.add('allow-forms');
    }

    public getIframeInstance(): HTMLIFrameElement | null {
        return this.iframe
    }

    private createLoader(): void {
        this.loader = document.createElement('div');
        this.loader.className = 'pn-embed-loader-container';

        const logo = document.createElement('div');
        logo.className = 'pn-embed-logo-loader';

        this.loader.appendChild(logo);

        if (this.modal) {
            this.modal.appendChild(this.loader);
        }
    }

    public open(url: string): void {
        if (!this.outer) this.createOuter();
        if (!this.modal) this.createModal();
        if (!this.iframe) this.createIframe();
        if (!this.loader) this.createLoader();

        if(this.iframe && this.modal && this.outer) {
            this.iframe.src = url;
            this.modal.appendChild(this.iframe);
            this.outer.style.display = 'flex';
        }

    }

    public refresh(url: string): void {
        this.open(url)

        this.showIframe()
    }

    public close(): void {
        if (this.outer) {
            this.outer.style.display = 'none';
            this.modal?.remove();
            this.iframe?.remove();
            this.loader?.remove();

            // reset to null
            this.modal = null;
            this.iframe = null;
            this.loader = null;
        }

        if (this.onClosed) {
            this.onClosed();
        }
    }

    public hideLoader(): void {
        if (this.loader) {
            this.loader.style.display = 'none';
        }
    }

    public showIframe(): void {
        if (this.iframe) {
            this.iframe.style.display = 'block';
        }
    }

    private createCloseButton(): void {
        const closeButton = document.createElement('button');
        closeButton.className = 'pn-embed-modal-close-icon-btn';
        closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90"><path fill="#fff" d="m49 45 14-14c.5-.5.8-1.3.9-2 .1-.8-.2-1.6-.7-2.1s-1.3-.8-2.1-.7c-.8 0-1.5.4-2 .9l-14 14-14-14c-.5-.5-1.3-.8-2-.9-.8-.1-1.6.2-2.1.7s-.8 1.3-.7 2.1c0 .8.4 1.5.9 2l14 14-14 14c-.5.5-.8 1.3-.9 2-.1.8.2 1.6.7 2.1s1.3.8 2.1.7c.8 0 1.5-.4 2-.9l14-14 14 14c.5.5 1.3.8 2 .9.8.1 1.6-.2 2.1-.7s.8-1.3.7-2.1c0-.8-.4-1.5-.9-2L49 45z"></path></svg>`;
        closeButton.onclick = () => {
            this.close();
        }

        if (this.outer) {
            this.outer.appendChild(closeButton);
        }
    }

    private loadStyles(): void {
        const style = document.createElement('style');
        style.innerHTML = `
            .pn-embed-modal-outer {
                position: fixed;
                z-index: 2147483640;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 50px;
                box-sizing: border-box;
            }
            .pn-embed-modal {
                width: 100%;
                height: 100%;
                background-color: transparent;
                border-radius: 8px;
                overflow: hidden;
                box-sizing: border-box;
            }
            
            .pn-embed-loader-container {
                width: 100%;
                height: 100%;
                box-sizing: border-box;
            }
            
            .pn-embed-logo-loader {
                display: block;
                overflow: hidden;
                position: absolute;
                background-size: 100%;
                background-position: 50%;
                background-repeat: no-repeat;
                height: 160px;
                width: 160px;
                left: calc(50% - 80px);
                top: calc(50% - 80px);
                background-image: url('${this.serverUrl}/embed/embed-loader.svg');
                animation: scaleInOut 3s infinite;
                transform-origin: 50% 50%;
                perspective: 1000px;
                box-sizing: border-box;
            }
            
            @keyframes scaleInOut {
                0% {
                    transform: scale(0.8) rotate(0deg);
                }
                50% {
                    transform: scale(1) rotate(12deg);
                }
                100% {
                    transform: scale(0.8) rotate(0deg);
                }
            }
            
            .pn-embed-modal-close-icon-btn {
              background: transparent;
              border: 0;
              cursor: pointer;
              height: 40px;
              position: fixed;
              right: 5px;
              top: 5px;
              width: 40px;
            }
        `;


        document.head.appendChild(style);
    }
}
